import React, { useState, useEffect, useContext } from "react";
import { UserContext } from "../context/UserContext";
import { ContentContext } from "../context/ContentContext";
import axios from "axios";
import { useParams, useHistory } from "react-router-dom";
import {
  Box,
  Container,
  Heading,
  Stack,
  Input,
  Button,
  ButtonGroup,
  FormControl,
  FormLabel,
  FormHelperText,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  useToast,
} from "@chakra-ui/react";

const MovieForm = () => {
  const { user } = useContext(UserContext);
  const { movies, setMovies, fetch, setFetch } = useContext(ContentContext);
  const [input, setInput] = useState({});
  const { id } = useParams();
  const history = useHistory();
  const toast = useToast();

  useEffect(() => {
    if (id) {
      axios
        .get(`https://backendexample.sanbersy.com/api/data-movie/${id}`)
        .then((res) => {
          setInput({
            id: res.data.id,
            title: res.data.title,
            description: res.data.description,
            year: res.data.year,
            duration: res.data.duration,
            genre: res.data.genre,
            rating: res.data.rating,
            review: res.data.review,
            image: res.data.image_url,
          });
        });
    }
  }, []);

  const handleChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    setInput({ ...input, [name]: value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (id) {
      axios
        .put(
          `https://backendexample.sanbersy.com/api/data-movie/${id}`,
          {
            title: input.title,
            description: input.description,
            year: input.year,
            duration: input.duration,
            genre: input.genre,
            rating: input.rating,
            review: input.review,
            image_url: input.image,
            token: user.token,
          },
          {
            headers: { Authorization: "Bearer " + user.token },
          }
        )
        .then(() => {
          let movie = movies.find((element) => element.id === parseInt(id));
          movie.title = input.title;
          movie.description = input.description;
          movie.year = input.year;
          movie.duration = input.duration;
          movie.genre = input.genre;
          movie.rating = input.rating;
          movie.review = input.review;
          movie.image = input.image;
          history.push("/movie/list");
          setFetch(!fetch);
          toast({
            title: "Edit movie success",
            position: "top",
            status: "success",
            duration: 1500,
          });
        })
        .catch((error) => console.log(error));
    } else {
      axios
        .post(
          `https://backendexample.sanbersy.com/api/data-movie`,
          {
            title: input.title,
            description: input.description,
            year: input.year,
            duration: input.duration,
            genre: input.genre,
            rating: input.rating,
            review: input.review,
            image_url: input.image,
            token: user.token,
          },
          {
            headers: { Authorization: "Bearer " + user.token },
          }
        )
        .then((res) => {
          let data = res.data;

          setMovies([
            ...movies,
            {
              id: data.id,
              title: data.title,
              description: data.description,
              year: data.year,
              duration: data.duration,
              genre: data.genre,
              rating: data.rating,
              review: data.review,
              image: data.image_url,
            },
          ]);
          history.push("/movie/list");
          setFetch(!fetch);
          toast({
            title: "Add movie success",
            position: "top",
            status: "success",
            duration: 1500,
          });
        })
        .catch((error) => console.log(error.message));
    }
  };

  return (
    <Box p={4}>
      <Container maxW="container.lg" p={4}>
        <Heading>{id ? "Edit Movie" : "Add Movie"}</Heading>
        <form onSubmit={handleSubmit}>
          <Stack spacing="1rem" py={4}>
            <FormControl>
              <FormLabel id="title" isRequired>
                Movie Title
              </FormLabel>
              <Input name="title" value={input.title} onChange={handleChange} />
              <FormHelperText>Provide a movie title</FormHelperText>
            </FormControl>
            <FormControl>
              <FormLabel id="genre" isRequired>
                Movie Genre
              </FormLabel>
              <Input name="genre" value={input.genre} onChange={handleChange} />
              <FormHelperText>Provide a movie genre</FormHelperText>
            </FormControl>
            <FormControl>
              <FormLabel id="year" isRequired>
                Movie Release Year
              </FormLabel>
              <NumberInput value={input.year}>
                <NumberInputField
                  name="year"
                  type="number"
                  min="1980"
                  max="2021"
                  value={input.year}
                  onChange={handleChange}
                />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
              <FormHelperText>Provide a movie year</FormHelperText>
            </FormControl>
            <FormControl>
              <FormLabel id="rating" isRequired>
                Movie Rating
              </FormLabel>
              <NumberInput value={input.rating}>
                <NumberInputField
                  type="number"
                  name="rating"
                  min="0"
                  max="10"
                  value={input.rating}
                  onChange={handleChange}
                />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
              <FormHelperText>Provide a movie rating</FormHelperText>
            </FormControl>
            <FormControl>
              <FormLabel id="duration" isRequired>
                Movie Duration
              </FormLabel>
              <NumberInput value={input.duration}>
                <NumberInputField
                  type="number"
                  name="duration"
                  min="0"
                  value={input.duration}
                  onChange={handleChange}
                />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
              <FormHelperText>
                Provide a movie duration in minutes
              </FormHelperText>
            </FormControl>
            <FormControl>
              <FormLabel id="description" isRequired>
                Movie Description
              </FormLabel>
              <Input
                name="description"
                value={input.description}
                onChange={handleChange}
              />
              <FormHelperText>Provide a movie description</FormHelperText>
            </FormControl>
            <FormControl>
              <FormLabel id="review" isRequired>
                Movie Review
              </FormLabel>
              <Input
                name="review"
                value={input.review}
                onChange={handleChange}
              />
              <FormHelperText>Provide a movie review</FormHelperText>
            </FormControl>
            <FormControl>
              <FormLabel id="image-url" isRequired>
                Movie Poster
              </FormLabel>
              <Input name="image" value={input.image} onChange={handleChange} />
              <FormHelperText>Provide a movie poster</FormHelperText>
            </FormControl>
            <ButtonGroup spacing="4">
              <Button
                type="submit"
                colorScheme="red"
                variant="outline"
                onClick={() => history.push("/movie/list")}
              >
                Cancel
              </Button>
              <Button type="submit" colorScheme="teal" variant="solid">
                Save
              </Button>
            </ButtonGroup>
          </Stack>
        </form>
      </Container>
    </Box>
  );
};

export default MovieForm;
